import '../assets/css/resume.css';
import profilePic from '../assets/images/myPic/MyPic-w-1050.png';
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { RiGlobalFill } from "react-icons/ri";
import { FaLinkedinIn, FaFileDownload } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import Button from './Button';

const Resume = () => {
    return (
        <div className="resume-container">
            <div className="resume-sub-container">
                <div className="resume-sub-container-2">
                    <div className="resume-top">
                        <h2> <span className="resume-name">Md Mohib Khan</span> <br /> <span className="resume-designation">Web Developer</span></h2>
                        {/* <button className="resume-download-btn">Download</button> */}
                        <Button calassName="link_btn resume-download-btn" text="Download" color="blue" url={"https://drive.google.com/file/d/1dcJokziBZOxS8O7EYrEWCDqp44-cUAos/view?usp=sharing"} />
                        <div className="resume-group">
                            <div className="resume-group-left-side">
                                <div className="resume-imgbx">
                                    <img className='resume-profile-image' src={profilePic} />
                                </div>
                            </div>
                            <div className="resume-group-right-side">
                                <p>
                                    I  am  a  highly  skilled  and  experienced  web  developer  with  4+  years  of  experience
                                    creating  responsive  and  engaging  websites  and  web  applications.  Passionate  about
                                    delivering  high-quality  work  on  time.
                                    <br /><br />
                                    I  have  a  strong  understanding  of  front-end  and
                                    back-end development, as well as experience with API integration.
                                </p>

                            </div>
                        </div>
                    </div>
                    <div className="resume-bottom">

                        <div className="resume-left-side">
                            <h4 className="resume-mobile-h-margin">Contact</h4>
                            <ul className="resume-contactInfo resume-mobile-c-margin">
                                <li>
                                    <span className="icon"><FaPhoneAlt /></span>
                                    <span className="text">+91 7091825476</span>
                                </li>
                                <li>
                                    <span className="icon"><MdEmail /></span>
                                    <span className="text">indianmohibkhan@gmail.com</span>
                                </li>
                                <li>
                                    <span className="icon"><RiGlobalFill /></span>
                                    <span className="text">www.mohibkhan.com</span>
                                </li>
                                <li>
                                    <span className="icon"><FaLinkedinIn /></span>
                                    <span className="text">www.linkedin.com/mohibkhan</span>
                                </li>
                                <li>
                                    <span className="icon"><FaLocationDot /></span>
                                    <span className="text">Delhi, India</span>
                                </li>
                            </ul>

                            <h4 className="adjst-margin">Education</h4>
                            <div className="resume-edu-group">
                                <div className="resume-edu-group-bx">
                                    <p> JUL 2018 <br /><span className="date-devider">|</span><br />JUL 2021</p>

                                    <div className="value">
                                        <b>MCA</b>
                                        <p>Master Of Computer Application from Aligarh Muslim University, Aligarh.</p>
                                    </div>
                                </div>
                                <div className="resume-edu-group-bx">
                                    {/* <p>2015-2018</p> */}
                                    <p> JUL 2015 <br /><span className="date-devider">|</span><br />JUL 2018</p>

                                    <div className="value">
                                        <b>B.Sc IT</b>
                                        <p>Bachelor of Science in Information Technology from Gossner College, Ranchi</p>
                                    </div>
                                </div>
                            </div>
                            <h4>Work Experience</h4>
                            <div className="resume-edu-group resume-exp-group">
                                <div className="resume-edu-group-bx">
                                    <p> SEP 2021 <br /><span className="date-devider">|</span><br /><span className="date-present">PRESENT</span></p>

                                    <div className="value">
                                        <b>Web Developer <br /> <span>ZMQ Development</span></b>
                                        <p> I develop web apps and APIs using <u>React.js</u>, <u>PHP</u>, and related technologies, handling both frontend and backend tasks. <br /> Additionally, I traveled to Uganda for ZMQ Development to train users and implement the ‘Uganda DAT TB Platform’ for the Ministry of Health.
                                        </p>
                                    </div>
                                </div>
                                <div className="resume-edu-group-bx">
                                    <p> APR 2021 <br /><span className="date-devider">|</span><br />AUG 2021</p>
                                    <div className="value">
                                        <b>Web Developer-Trainee <br /> <span>ZMQ Development</span></b>
                                        <p>During my internship, I developed a web application to manage DS TB patient data, working on both frontend and backend.<br /> I also gained experience with <u>RESTful APIs</u>, <u>MVC Pattern</u>, and <u>Git</u>.</p>
                                    </div>
                                </div>
                            </div>



                        </div>
                        <div className="resume-right-side">

                            <h4 className="resume-mobile-skill-h">Skills</h4>
                            <div className="resume-skills">
                                <div className="resume-skills-box" style={{ '--i': '95%' }}>
                                    <p>JavaScript</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '95%' }}>
                                    <p>PHP</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '90%' }}>
                                    <p>ReactJs</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '70%' }}>
                                    <p>NodeJs</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '95%' }}>
                                    <p>MySQL</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '95%' }}>
                                    <p>RestAPI</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '95%' }}>
                                    <p>Codeigniter</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '95%' }}>
                                    <p>HTML</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '90%' }}>
                                    <p>CSS</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '90%' }}>
                                    <p>Bootstrap</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '90%' }}>
                                    <p>Git & GitHub</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                                <div className="resume-skills-box" style={{ '--i': '20%' }}>
                                    <p>AWS</p>
                                    <div className="resume-skills-value"></div>
                                </div>
                            </div>

                            <h4 className="resume-mobile-skill-h">Projects</h4>
                            <div className="resume-projects-container">
                                <div className="resume-project">
                                    <span className="resume-project-heading"> PMNE  — (Project Monitoring And Evaluation)  <span>Web Application</span></span>
                                    <div className="resume-project-contents">
                                        <p>Led the development of a project management system, improving team collaboration and data collection. Designed and implemented survey and quiz forms to enhance feedback and performance evaluation. Built a dynamic form builder with drag-and-drop functionality using <u>JavaScript</u> and <u>React.js</u>, enabling organizations to create custom forms for various use cases.</p>
                                        <p>Utilized technologies like <u>PHP</u>, <u>Codeigniter</u>, <u>MySQL</u>, <u>RESTful APIs</u>, <u>Bootstrap</u>, and <u>Font Awesome</u> to build a scalable platform. Collaborated with cross-functional teams to gather requirements, design new features, and ensure timely delivery of high-quality code.</p>
                                    </div>
                                </div>

                                <div className="resume-project">
                                    <span className="resume-project-heading">Uganda DAT TB Platform - <span>Web Application</span></span>
                                    <div className="resume-project-contents">
                                        <p>Developed and designed a web  application from scratch to monitor and manage data of TB patients.</p>

                                        <p>Created a digital platform for  registering, uploading test reports,  patient report adherence by video, dot,  pill box, monitoring patient adherence to  medication through adherence calendar.</p>

                                        <p>Designed an adherence calendar for doctors to monitor patient adherence reporting and make necessary adjustments to the treatment plan.</p>

                                        <p>Used technologies are <u>JavaScript</u>, <u>Bootstrap</u>, <u>Font Awesome</u>, and <u>Fetch API</u>,
                                            <u>PHP</u>, <u>RESTful API</u>, <u>MySQL</u>, <u>Codeigniter Framework</u> and followed the <u>MVC</u>
                                            &nbsp;pattern for this web app.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Resume;
